import React, { useEffect, useState } from "react"
import { Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"

import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Modal from "@mui/material/Modal"
import TextField from "@mui/material/TextField"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import AddIcon from "@mui/icons-material/Add"
import { toast } from "react-toastify"
import axios from "axios"
import { useMutation, useQuery } from "react-query"
import { deletePlanTypeFn, getPlanTypeFn, patchPlanTypeFn, postPlanTypeFn } from "Services/Plan Management"
import { imageURL } from "Config/endpoints"
import { useDebouncedQueryValue } from "Hooks/useDebouncedQueryValue"
import CryptoJS from 'crypto-js';
import { deleteTradeShowFn, getTradeShowFn, patchTradeShowFn, postTradeShowFn } from "Services/TradeShow"
import { deleteExhibitionFn, getExhibitionFn, patchExhibitionFn, postExhibitionFn } from "Services/Exhibtion"
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    rounded: 2,
}

const TradeExhibtion = () => {

    const [open, setOpen] = React.useState(false)
    const [page, setPage] = useState(1)
    const [searchQuery, setSearchQuery] = useState("")
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPage, setTotalPage] = useState(null)

    const [title, setTitle] = useState("")
    const [location, setLocation] = useState("")

    const [start_date, setStart_date] = useState("")

    const [end_date, setEnd_date] = useState("")

    const [description, setDescription] = useState("")

    const [ids, setIds] = useState(null)
    const [rowData, setRowData] = useState({})

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)

    const previousData = () => {
        if (page > 1) {
            setPage(page - 1)
        }
    }
    const nextData = () => {
        if (page < totalPage) {
            setPage(page + 1)
        }
    }



    const debouncedSearch = useDebouncedQueryValue(searchQuery, 500);


    const { data, refetch } = useQuery(["tradeshows", debouncedSearch], () => getExhibitionFn({ search: debouncedSearch, page: page }))
    const TradeShows = data?.data?.data











    const { mutate: DeleteTradeShow } = useMutation(deleteExhibitionFn, {
        onSuccess: (response) => {

            if (response.data.response_code === 200) {

                toast.success(response.data.message)
                refetch()

            }


            else {

                toast.warn(response.data.message)






            }




        }
    })


    const { mutate: AddTradeShow } = useMutation(postExhibitionFn, {
        onSuccess: (response) => {

            if (response.data.response_code === 200) {

                toast.success(response.data.message)
                refetch()
                setTitle("")
                setLocation("")
                setStart_date("")
                setDescription("")
                setEnd_date("")
                setRowData({})
                setIds(null)
                handleClose()
            }


            else {

                toast.warn(response.data.message)






            }




        }
    })


    const { mutate: UpdateTradeShow } = useMutation(patchExhibitionFn, {
        onSuccess: (response) => {

            if (response.data.response_code === 200) {

                toast.success(response.data.message)
                refetch()
                setTitle("")
                setLocation("")
                setStart_date("")
                setDescription("")
                setEnd_date("")
                setRowData({})
                setIds(null)
                handleClose()
            }


            else {

                toast.warn(response.data.message)

            }


        }
    })




    // const PlanDataList = () => {
    //   axios
    //     .get(`plan-type-list-api-for-superadmin/?page=${page}&search_value=${searchQuery}`, {
    //       headers: {
    //         Authorization: localStorage.getItem("token"),
    //       },
    //     })
    //     .then((response) => {
    //       console.log("plan type data list===>", response?.data?.data)
    //       setData(response?.data?.data)
    //       setCurrentPage(response?.data?.current_page)
    //       setTotalPage(response?.data?.total_pages)
    //     })
    //     .catch((error) => {
    //       console.log("", error.response)
    //       console.log(error)
    //     })
    // }

    // useEffect(() => {
    //   PlanDataList()
    // }, [page, searchQuery])
    const handleCloseModal = () => {
        setTitle("")
        setLocation("")
        setStart_date("")
        setDescription("")
        setEnd_date("")
        setRowData({})
        setIds(null)
        handleClose()
    }

    const submitData = () => {
        const fd = new FormData()
        fd.append("title", title)
        fd.append("location", location)
        fd.append("start_date", start_date)
        fd.append("end_date", end_date)

        fd.append("description", description)

        fd.append("exhibition_id", ids)

        ids === null
            ? AddTradeShow(fd)
            : UpdateTradeShow(fd)
    }

    const editFunction = (row) => {
        setIds(row?.id)
        setRowData(row)




        setTitle(row?.title)
        setLocation(row?.location)
        setStart_date(row?.start_date)
        setEnd_date(row?.end_date)
        setDescription(row?.description)

        handleOpen()
    }

    // const notAppliCable = () => {
    //   alert("this feature not available present time...");
    // };

    return (
        <div className=" !bg-slate-100">
            <div className="flex justify-between">
                <div className="p-2">
                    <p className="text-xl !text-black font font-bold">Exhibition List</p>
                </div>
                <div className="p-2 pt-5">{/* <CreateResellers /> */}</div>
            </div>
            <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
                <div className="flex items-center justify-between my-2">
                    <span className="flex  gap-3">
                        <input
                            class="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
                            placeholder="Search for anything..."
                            type="text"
                            value={searchQuery}
                            onChange={(event) => setSearchQuery(event.target.value)}
                        />
                    </span>
                    <span>
                        {/* Add Category Bussiness start */}

                        <div className="text-red-500 mx-3">
                            <Button variant="outlined" color="primary" onClick={handleOpen}>
                                <AddIcon /> Add Exhibition
                            </Button>
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="child-modal-title"
                                aria-describedby="child-modal-description"
                            >
                                <Box sx={{ ...style, width: 450 }} className="rounded-2xl !border-0 !shadow-sm !shadow-blue-900">
                                    <div
                                        id="child-modal-title "
                                        className="!text-black !underline !underline-offset-2  !font-bold pb-3 !text-center !text-xl"
                                    >
                                        {ids === null ? "Add Exhibition" : "Update Exhibition"}
                                    </div>
                                    <div className="">
                                        <div>Title</div>
                                        <TextField
                                            value={title}
                                            onChange={(event) => setTitle(event.target.value)}
                                            id="outlined-basic"
                                            size="small"
                                            className="!w-[100%] !m-1"
                                        />
                                        <div className="mt-2">Location</div>
                                        <TextField
                                            value={location}
                                            onChange={(event) => setLocation(event.target.value)}
                                            id="outlined-basic"
                                            type="text"
                                            size="small"
                                            className="!w-[100%] !m-1"
                                        />


                                        <div className="mt-2"> Start Date </div>
                                        <TextField
                                            value={start_date}
                                            onChange={(event) => setStart_date(event.target.value)}
                                            id="outlined-basic"
                                            type="date"
                                            size="small"
                                            className="!w-[100%] !m-1"
                                        />

                                        <div className="mt-2"> End Date </div>
                                        <TextField
                                            value={end_date}
                                            onChange={(event) => setEnd_date(event.target.value)}
                                            id="outlined-basic"
                                            type="date"
                                            size="small"
                                            className="!w-[100%] !m-1"
                                        />


                                        <div className="mt-2">Description</div>
                                        <TextField
                                            value={description}
                                            onChange={(event) => setDescription(event.target.value)}
                                            multiline
                                            rows={2}

                                            id="outlined-basic"
                                            type="text"
                                            size="small"
                                            className="!w-[100%] !m-1"
                                        />


                                    </div>
                                    <br />
                                    <Button onClick={handleCloseModal} variant="contained" color="warning" className="!py-2">
                                        CANCEL
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        className="!py-2 !px-5 !font-bold !float-right"
                                        onClick={submitData}
                                    >
                                        {ids == null ? "Add" : "UPDATE"}
                                    </Button>
                                </Box>
                            </Modal>
                        </div>
                    </span>
                </div>
                <TableContainer
                    component={Paper}
                    sx={{ width: "100%", maxHeight: 440 }}
                    className="!text-black !mx-auto !bg-white overflow-auto px-2"
                >
                    <Table stickyHeader aria-label="sticky table" size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    SR. No.
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    NAME
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    VENUE
                                </TableCell>

                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    DATE
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    DETAIL
                                </TableCell>

                                <TableCell
                                    style={{
                                        borderRight: "1px solid #D0D0D0",
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    DESCRIPTION
                                </TableCell>
                                {/* <TableCell style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold">
                  STATUS
                </TableCell> */}
                                <TableCell
                                    style={{
                                        fontFamily: "'Poppins', sans-serif",
                                    }}
                                    className="!text-center !text-gray-800 !font-bold"
                                >
                                    ACTION
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className="!bg-red">
                            {TradeShows &&
                                TradeShows?.map((row, index) => (
                                    <TableRow key={row.id} className="!text-slate-700">
                                        {/* <TableCell
                        className="!text-left !p-2 !text-black"
                        component="th"
                        scope="row"
                      >
                        <Checkbox className="!m-0 !text-slate-700" />
                      </TableCell> */}
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {index + 1}
                                        </TableCell>
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row.title ? row.title : "--"}
                                        </TableCell>
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row?.location || "--"}

                                        </TableCell>


                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row?.start_date || "--"}

                                        </TableCell>

                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row?.end_date || "--"}

                                        </TableCell>


                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                borderRight: "1px solid #D0D0D0",
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            {row?.description || "--"}

                                        </TableCell>
                                        {/* <TableCell className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}>
                        {row?.business_type?.name}
                      </TableCell> */}
                                        <TableCell
                                            className="!text-center !text-[12px]"
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                            }}
                                        >
                                            <DeleteIcon onClick={() => DeleteTradeShow({ exhibition_id: row?.id })} className="!text-xl !text-red-600 !cursor-pointer" />
                                            <EditIcon
                                                className="!text-xl !cursor-pointer !text-green-600"
                                                onClick={() => editFunction(row)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div
                    className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400  flex !flex-col !justify-end !items-end"
                    style={{ marginRight: "0px" }}
                >


                    <Pagination count={data?.data?.total_pages} value={data?.data?.current_page} onChange={(_, value) => setPage(value)} variant="outlined" shape="rounded" />
                    {/* <button onClick={nextData} className="!float-right">
            {data?.data?.current_page}...{data?.data?.total_pages}
            <ArrowForwardIosIcon />
          </button>
          <button onClick={previousData} className="float-right">
            <ArrowBackIosIcon />
          </button> */}
                </div>
            </div>
        </div>
    )
}

export default TradeExhibtion
